import React from 'react';
import SubpageTemplate from '../../components/SubpageTemplate';
import { Sparkles, Zap, TrendingUp, Users, Target, Rocket } from 'lucide-react';

export default function UseCaseStartups() {
  return (
    <SubpageTemplate 
      title="Founders & Startups"
      subtitle="From MVP to PMF"
      description="Don't spend 3 months building a prototype. Synthesize your vision into a launchable product in a single afternoon. Focus on validation, not boilerplate."
      icon={Rocket}
      features={[
        {
          title: "Rapid Validation",
          description: "Generate and test landing pages and functional prototypes before writing a single line of legacy code.",
          icon: Target
        },
        {
          title: "Lean Engineering",
          description: "Maintain a high iterate-to-burn ratio. SHIP more features with fewer developers.",
          icon: Zap
        },
        {
          title: "GTM Intelligence",
          description: "Automated distribution kits to get your first 100 users without the marketing overhead.",
          icon: TrendingUp
        }
      ]}
    />
  );
}
